module.exports = __webpack_public_path__ + "static/img/3.f5dc51d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/2/3.png
// module id = d9NP
// module chunks = 0